import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {schoolNameState, teacherIdState, teacherNameState} from "../../recoil/teacher/teacherIdState";
import {
    useRecoilRefresher_UNSTABLE,
    useRecoilState,
    useRecoilValue,
    useRecoilValueLoadable,
    useSetRecoilState
} from "recoil";
import {classesState, fetchClassesSelector, mainClassState, savedClassesState} from "../../recoil/classes/classesState";
import {useEffect, useLayoutEffect, useState} from "react";
import {cloneDeep} from "lodash";
import {getActiveLicenses, getLicensesListYear, getStudents, updateStudents} from "../../network/Endpoint";
import TopMenu from "../../components/TopMenu";
import LicenseNavigation from "./components/LicenseNavigation";
import NavigationLine from "../../assets/images/classes/line.svg";
import RegistrationVoucherPage from "./registration/RegistrationVoucherPage";
import ActiveLicensePage from "./active/ActiveLicensePage";
import LicenseHistoryPage from "./history/LicenseHistoryPage";
import SideMenu from "../../components/SideMenu";
import { topMenuTypeState} from "../../recoil/menuState/topMenuState";

const LicensePage = () => {
    const teacherId = useRecoilValue(teacherIdState);
    const location = useLocation();
    const classes= useRecoilValue(classesState); // classes atom 업데이트
    const mainClass = useRecoilValue(mainClassState);

    const [selectedClass, setSelectedClass] = useState(null);
    const [activeTab, setActiveTab] = useState(null);

    const [activeLicenses, setActiveLicenses] = useState(null);
    const [licensesYear, setLicensesYear] = useState(null);

    const [isEditable, setIsEditable] = useState(false);

    const setMenuType = useSetRecoilState(topMenuTypeState);

    useEffect(() =>  {
        if(setMenuType){
            setMenuType("license");
        }
    },[setMenuType])

    useLayoutEffect(  () => {
        if(!window.location.pathname.includes('/page')){
            window.history.replaceState(null, "", "/"); // 주소창에서 경로를 숨김
        }
    }, [location.pathname]);

    /**
     * 적용 가능한 라이센스 가져오기
     * @returns {Promise<void>}
     */
    const fetchActiveLicenses = async () => {
        try {
            const body = {
                teacherId: teacherId
            }
            const res = await getActiveLicenses(body);

            const statusCode = res.data.status.code;
            if(statusCode === 'Success') {
                const licenses = cloneDeep(res.data.data.licenseList)
                console.log(licenses);
                setActiveLicenses(licenses);
                fetchLicensesYearList();
                if((activeTab==null||activeTab==="activeLicense")&&licenses!=null){
                    setActiveTab("activeLicense");
                }else{
                    setActiveTab("registration");
                }
            }else {
                alert(`ERROR: 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        }catch (error) {
            alert(`[${error.message}]\n이용권 불러오는 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        }
    }

    /**
     * 지금까지 구매한 라이센스 가져오기
     * @returns {Promise<void>}
     */
    const fetchLicensesYearList = async () => {
        try {
            const body = {
                teacherId: teacherId
            }
            const res = await getLicensesListYear(body);

            const statusCode = res.data.status.code;
            if(statusCode === 'Success') {
                const licenses = cloneDeep(res.data.data.licenseYearList)
                setLicensesYear(licenses);
            }else {
                alert(`ERROR: 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        }catch (error) {
            alert(`[${error.message}]\n오류가 발생했어요. 아크수학으로 문의해 주세요.`);
        }
    }

    useEffect(() => {
        if(teacherId && mainClass && !selectedClass){
            setSelectedClass(mainClass);
            fetchActiveLicenses();
        } else if(teacherId && activeLicenses === null) {
            fetchActiveLicenses();
        }
    }, [teacherId, mainClass])


    return (
        <div className="flex flex-col items-center w-full max-md:max-w-full bg-[#F8F8F8] min-h-screen">
            <div className="flex flex-col items-center justify-center  w-full">
                <LicenseNavigation
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    setIsEditable={setIsEditable}
                />
                <div className="w-full flex justify-center items-center ">
                    <img
                        loading="lazy"
                        src={NavigationLine}
                        alt=""
                        className="mt-8  w-[1044px]"
                    />
                </div>
                {/* 조건부 렌더링 */}
                {activeTab === "registration" && (
                    <>
                        <RegistrationVoucherPage
                            teacherId={teacherId}
                            fetchActiveLicenses={fetchActiveLicenses}
                            fetchLicensesYearList={fetchLicensesYearList}
                        />
                    </>
                )}
                {activeTab === "activeLicense" && (
                    <>
                        <ActiveLicensePage
                            activeLicenses={activeLicenses}
                            setActiveLicenses={setActiveLicenses}
                            classes={classes}
                            selectedClass={selectedClass}
                            setSelectedClass={setSelectedClass}
                            isEditable={isEditable}
                            setIsEditable={setIsEditable}
                            mainClass={mainClass}
                        />
                    </>
                )}
                {activeTab === "licenseHistory" && (
                    <>
                        <LicenseHistoryPage
                            licensesYear={licensesYear}
                        />
                    </>
                )}
            </div>

            <SideMenu></SideMenu>
        </div>
    )
}

export default LicensePage;